import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { DemandasMonitoramento } from '../models/demandas-monitoramento.model';
import { DemandasMonitoramentoService } from '../services/demandas-monitoramento.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-demandas-monitoramento-list',
  templateUrl: './demandas-monitoramento-list.component.html',
  styleUrls: ['./demandas-monitoramento-list.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ]
})
export class DemandasMonitoramentoListComponent extends BaseListComponent<DemandasMonitoramento> implements OnInit, OnDestroy {

  form: FormGroup;
  usuarioList: Usuario[];
  list: any;
  situacaoList: any[];
  filterActive: boolean = true;
  demandas: DemandasMonitoramento[];
  lengthDemandas: boolean = false;

  constructor(
    private myService: DemandasMonitoramentoService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
    this.list = this.activatedRoute.snapshot.data["listAndamento"];
    this.situacaoList = this.activatedRoute.snapshot.data["listSituacao"];
    this.initForm();
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initForm() {
    this.form = new FormGroup({
      filter_agency: new FormControl(null),
      filter_defendant_id: new FormControl(null),
      filter_issue_sub_stat_id: new FormControl(null),
      filter_status1_id: new FormControl(null),
      filter_demandant_id: new FormControl(null),
    })
  }

  cleanSearch() {
    this.form.reset();
  }

  getDataCreate() {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  search() {
    this.loading();
    this.addSub(
      this.myService.getListSearch(this.getDataCreate()).subscribe((res) => {
        this.lengthDemandas = !res.length;
        this.demandas = res;
        this.loaded();
      })
    );
  }

  view(id: number) {
    return ['/projetos', 'demandas-monitoramento', id, 'mensagens'];
  }

  alertMail(data) {
    this.alertConfirmation(data, 'Enviar e-mail solicitando atenção?').subscribe((confirmed) => {
      if (confirmed) {
        this.sendMail(data);
      }
    });
  }

  sendMail(data: any): void {
    this.loading();
    this.myService.sendMail(data.id).subscribe({
      next: (res) => {
        this.msgSuccess(res.message);
        this.loaded();
      },
      error: (error) => {
        this.msgError(error.erro?.message)
        this.loaded();
      }
    });
  }

}
